import React from "react";
import { useSelector } from "react-redux";
import { selectFertigation } from "../../../redux/selectors";

const PrintFertigation = () => {
  const fertigationDetails = useSelector(selectFertigation);

  const isZoneEmpty = (detail) => {
    return (
      !detail.WatertronicsFertigation &&
      !detail.WatertronicsStyle &&
      !detail.TankSize &&
      !detail.TankBottomType &&
      !detail.LiquidTankByWatertronics &&
      !detail.TankQuantity &&
      !detail.TankLevelSensor &&
      !detail.TankLevelSensorQuantity &&
      !detail.FertigationComments &&
      !detail.HasTBD &&
      !detail.HasFertigation &&
      !detail.FertigationQuantity &&
      !detail.Quantity10 &&
      !detail.Quantity25 &&
      !detail.HoseType &&
      !detail.QuillType
    );
  };

  const renderDetails = (details) => {
    if (!details || !Array.isArray(details) || details.length === 0) {
      return null;
    }

    return (
      <div>
        {details
          .filter((detail) => detail && detail.HasFertigation && Object.keys(detail).length > 0)
          .map((detail, index) => {
            if (isZoneEmpty(detail)) {
              return null;
            }
            return (
              <div className="section" key={index}>
                <table className="table table-bordered full-width">
                  <tbody>
                    <h3 className="print-zone-label">Zone: {detail.Zone}</h3>
                    <tr>
                      <td className="col-md-6">
                        <table>
                          <tbody>
                            <tr><td><strong>Watertronics Fertigation: </strong>{detail.WatertronicsFertigation}</td></tr>
                            <tr><td><strong>Tank Size: </strong>{detail.TankSize}</td></tr>
                            <tr><td><strong>Liquid Tank By Watertronics: </strong>{detail.LiquidTankByWatertronics}</td></tr>
                            <tr><td><strong>Tank Level Sensor: </strong>{detail.TankLevelSensor}</td></tr>
                            <tr><td><strong>Fertigation Quantity: </strong>{detail.FertigationQuantity}</td></tr>
                            <tr><td><strong>Quantity of 10' Hose: </strong>{detail.Quantity10}</td></tr>
                            <tr><td><strong>Hose Type: </strong>{detail.HoseType}</td></tr>
                          </tbody>
                        </table>
                      </td>
                      <td className="col-md-6">
                        <table>
                          <tbody>
                            <tr><td><strong>Watertronics Style: </strong>{detail.WatertronicsStyle}</td></tr>
                            <tr><td><strong>Tank Bottom Type: </strong>{detail.TankBottomType}</td></tr>
                            <tr><td><strong>Tank Quantity: </strong>{detail.TankQuantity}</td></tr>
                            <tr><td><strong>Tank Level Sensor Quantity: </strong>{detail.TankLevelSensorQuantity}</td></tr>
                            <tr><td><strong>Quantity of 25' Hose: </strong>{detail.Quantity25}</td></tr>
                            <tr><td><strong>Quill Type: </strong>{detail.QuillType}</td></tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p><strong>Comments:</strong><br />{detail.FertigationComments}</p>
                <br className="clearfix" />
              </div>
            );
          })}
      </div>
    );
  };

  return (
    <div>
      {fertigationDetails && fertigationDetails.some(detail => detail.HasFertigation) && (
        <h2 className="print-section-header">Fertigation Summary</h2>
      )}
      {renderDetails(fertigationDetails)}
    </div>
  );
};

export default PrintFertigation;
